import apiClient from './service';

export const uploadService = (data: any) => {
  return apiClient(true)
    .post('/uploads', data)
    .then((res) => res.data);
};
